import { Box } from '@redbubble/design-system';
import React from 'react';
import styles from './ImageFloatingLabel.module.scss';

interface ImageFloatingLabelProps {
  labelText: string;
}

export const ImageFloatingLabel: React.FC<ImageFloatingLabelProps> = ({
  labelText,
}) => {
  return <Box className={styles.label}>{labelText}</Box>;
};
